import React, { createContext, useContext } from 'react';

const AuthProviderContext = createContext(null);

/**
 * Este es el componente "Proveedor" que usaremos en App.js.
 * Recibe el authProvider activo y lo hace disponible para todos sus hijos.
 * @param {{children: React.ReactNode, provider: object}} props
 */
export const DynamicAuthProvider = ({ children, provider }) => {
  return (
    <AuthProviderContext.Provider value={provider}>
      {children}
    </AuthProviderContext.Provider>
  );
};

/**
 * Este es el hook personalizado que usarán los componentes hijos.
 * Les da acceso directo al authProvider activo sin necesidad de props.
 * @returns {object} El authProvider activo (authProviderMX o authProviderEU).
 */
export const useDynamicAuth = () => {
  const context = useContext(AuthProviderContext);
  if (context === undefined) {
    throw new Error('useDynamicAuth debe ser usado dentro de un DynamicAuthProvider');
  }
  return context;
};
